import React, { FormEventHandler } from "react";
import styled from "styled-components";
import { Button, Theme, colors } from "@literati/public-ui-shared-react";
import { OnToken, PaymentMethod } from "components/Payment/paymentTypes";

export const FORM_ID = "default-payment-method";

export type DefaultPaymentMethodType = "stripe" | "paypal";
export type DefaultPaymentMethod = {
  type: DefaultPaymentMethodType;
  description: string;
};

export interface PaymentFormDefaultPaymentProps {
  className?: string;
  defaultPaymentMethod: DefaultPaymentMethod;
  hasDefaultPaymentMethod: boolean;
  onPaymentMethodChange: (paymentMethod: PaymentMethod) => void;
  onToken: OnToken;
  paymentMethod: PaymentMethod;
}

const ExistingMethodToggle = styled.div`
  margin: 1rem 0 0;
  padding: 1rem 1.25rem;
  font-size: 0.875rem;
  border-radius: 4px;
  border: 1px solid ${colors.black};
`;

export const PaymentFormDefaultPayment = ({
  className = "",
  defaultPaymentMethod,
  hasDefaultPaymentMethod,
  onPaymentMethodChange,
  onToken,
  paymentMethod,
}: PaymentFormDefaultPaymentProps) => {
  const { description, type } = defaultPaymentMethod;
  const defaultPaymentTypeDisplay = type === "stripe" ? "Credit Card" : null;

  const handleSubmit: FormEventHandler<HTMLFormElement> = (e) => {
    e.preventDefault();
    return onToken({ useDefault: true });
  };

  return (
    <Theme>
      <form className={className} id={FORM_ID} onSubmit={handleSubmit}>
        {hasDefaultPaymentMethod && paymentMethod === "default" ? (
          <ExistingMethodToggle>
            {defaultPaymentTypeDisplay ? (
              <p css="font-weight: 500">{defaultPaymentTypeDisplay}</p>
            ) : null}
            <p css={defaultPaymentTypeDisplay && "margin: 0.5rem 0 0"}>
              {description}
            </p>
            <Button
              css="margin: 1rem 0 0"
              onClick={() => onPaymentMethodChange("stripe")}
              type="button"
              variant="link"
            >
              Change Payment Method
            </Button>
          </ExistingMethodToggle>
        ) : null}
      </form>
    </Theme>
  );
};

export default PaymentFormDefaultPayment;
